module.exports = __webpack_public_path__ + "img/Icon_2.cdbc9913.svg";